import { render } from "./AdminSnippets.vue?vue&type=template&id=0b9d897f&scoped=true"
import script from "./AdminSnippets.vue?vue&type=script&lang=js"
export * from "./AdminSnippets.vue?vue&type=script&lang=js"

import "./AdminSnippets.vue?vue&type=style&index=0&id=0b9d897f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9d897f"]])

export default __exports__